import {IPageableDto} from './../../shared/types/pageable.types';
import {atom} from 'recoil';

import {IDeviceTypesDict} from '../../shared/types/deviceTypesDict.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const deviceTypesDictQueryTrigger = atom<number>({
  key: 'deviceTypesDictQueryTrigger',
  default: 0,
});

export const deviceTypesDictQueryByCodeTrigger = atom<number>({
  key: 'deviceTypeDictQueryByCodeTrigger',
  default: 0,
});

export const deviceTypesState = atom<IPageableDto<IDeviceTypesDict>>({
  key: 'deviceTypesState',
  default: getEmptyPage<IDeviceTypesDict>(),
});

export const currentDeviceTypeState = atom<IDeviceTypesDict | null>({
  key: 'currentDeviceTypeState',
  default: null,
});

export const currentDeviceTypeCodeState = atom<string | null>({
  key: 'currentDeviceTypeCodeState',
  default: null,
});

export const deviceTypeMapWithNamesState = atom<Map<string, string>>({
  key: 'deviceTypeMapWithNamesState',
  default: new Map<string, string>(),
});
